import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec60834a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h5-detail" }
const _hoisted_2 = { class: "nav-bar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-left" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 返回 ")
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav-title" }, "报告详情", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav-placeholder" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-pulse fa-2x" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "加载中...", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "tab-bar" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-pdf-o" }, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 报告文件 ")
const _hoisted_15 = {
  key: 0,
  class: "tab-badge"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-list-alt" }, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 报告详情 ")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "tab-content" }
const _hoisted_20 = {
  key: 0,
  class: "pdf-container"
}
const _hoisted_21 = { class: "pdf-header" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-pdf-o" }, null, -1))
const _hoisted_23 = { class: "pdf-name" }
const _hoisted_24 = ["href", "download", "title"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-cloud-download" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["src"]
const _hoisted_28 = {
  key: 1,
  class: "empty-tab"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-o fa-2x" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂无报告文件", -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = { class: "tab-content" }
const _hoisted_33 = { class: "code-badge" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-qrcode" }, null, -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode("查询验证码：")
const _hoisted_36 = { class: "info-card" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-text-o" }),
  /*#__PURE__*/_createTextVNode(" 报告信息 ")
], -1))
const _hoisted_38 = { class: "info-list" }
const _hoisted_39 = { class: "info-row" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "报告标题", -1))
const _hoisted_41 = { class: "value" }
const _hoisted_42 = { class: "info-row" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "报告编号", -1))
const _hoisted_44 = { class: "value highlight" }
const _hoisted_45 = { class: "info-row" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "检测结果", -1))
const _hoisted_47 = { class: "info-row" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "报告性质", -1))
const _hoisted_49 = { class: "value" }
const _hoisted_50 = { class: "info-row" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "报告类别", -1))
const _hoisted_52 = { class: "value" }
const _hoisted_53 = { class: "info-row" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "报告日期", -1))
const _hoisted_55 = { class: "value" }
const _hoisted_56 = { class: "info-card" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-building-o" }),
  /*#__PURE__*/_createTextVNode(" 检测信息 ")
], -1))
const _hoisted_58 = { class: "info-list" }
const _hoisted_59 = { class: "info-row" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "检测项目", -1))
const _hoisted_61 = { class: "value" }
const _hoisted_62 = { class: "info-row" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "检测机构", -1))
const _hoisted_64 = { class: "value" }
const _hoisted_65 = { class: "info-row" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "企业名称", -1))
const _hoisted_67 = { class: "value" }
const _hoisted_68 = { class: "info-row" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "联系电话", -1))
const _hoisted_70 = { class: "value" }
const _hoisted_71 = { class: "info-card" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-cube" }),
  /*#__PURE__*/_createTextVNode(" 产品信息 ")
], -1))
const _hoisted_73 = { class: "info-list" }
const _hoisted_74 = { class: "info-row" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "生产厂家", -1))
const _hoisted_76 = { class: "value" }
const _hoisted_77 = { class: "info-row" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "产品名称", -1))
const _hoisted_79 = { class: "value" }
const _hoisted_80 = { class: "info-row" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "产品产地", -1))
const _hoisted_82 = { class: "value" }
const _hoisted_83 = {
  key: 0,
  class: "info-card"
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-align-left" }),
  /*#__PURE__*/_createTextVNode(" 报告简介 ")
], -1))
const _hoisted_85 = { class: "desc-content" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-space" }, null, -1))
const _hoisted_87 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-text-o fa-3x" }, null, -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "报告信息不存在或已被删除", -1))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "back-btn",
        onClick: _cache[0] || (_cache[0] = (...args) => ($options.goBack && $options.goBack(...args)))
      }, _hoisted_5),
      _hoisted_6,
      _hoisted_7
    ]),
    ($data.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
      : _createCommentVNode("", true),
    (!$data.loading && $data.data.id)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              class: _normalizeClass(["tab-item", { active: $data.activeTab === 'files' }]),
              onClick: _cache[1] || (_cache[1] = $event => ($data.activeTab = 'files'))
            }, [
              _hoisted_13,
              _hoisted_14,
              ($data.data.fileList && $data.data.fileList.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString($data.data.fileList.length), 1))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["tab-item", { active: $data.activeTab === 'info' }]),
              onClick: _cache[2] || (_cache[2] = $event => ($data.activeTab = 'info'))
            }, _hoisted_18, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["tab-slider", $data.activeTab])
            }, null, 2)
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_19, [
            ($data.data.fileList && $data.data.fileList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.data.fileList, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "pdf-wrapper"
                    }, [
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("span", _hoisted_23, _toDisplayString(item.fileName), 1),
                        _createElementVNode("a", {
                          class: "pdf-download",
                          href: $data.pdfBlobUrls[index] || item.url,
                          download: item.fileName || '报告.pdf',
                          title: '下载 ' + (item.fileName || '')
                        }, _hoisted_26, 8, _hoisted_24)
                      ]),
                      _createElementVNode("iframe", {
                        class: "pdf-iframe",
                        src: $data.pdfBlobUrls[index] || item.url,
                        frameborder: "0"
                      }, null, 8, _hoisted_27)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_31))
          ], 512), [
            [_vShow, $data.activeTab === 'files']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("span", null, [
                _hoisted_35,
                _createElementVNode("strong", null, _toDisplayString($data.data.code1), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createElementVNode("span", _hoisted_41, _toDisplayString($data.data.title), 1)
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createElementVNode("span", _hoisted_44, _toDisplayString($data.data.code), 1)
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createElementVNode("span", {
                    class: _normalizeClass(["value", $data.data.testResult === 1 ? 'pass' : 'fail'])
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass($data.data.testResult === 1 ? 'fa fa-check-circle' : 'fa fa-times-circle')
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString($data.data.testResult === 1 ? '符合' : '不符合'), 1)
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("span", _hoisted_49, _toDisplayString($data.data.isOpen ? '公开' : '不公开'), 1)
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _hoisted_51,
                  _createElementVNode("span", _hoisted_52, _toDisplayString($data.data.typeName), 1)
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createElementVNode("span", _hoisted_55, _toDisplayString($data.data.testTime), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _hoisted_57,
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _hoisted_60,
                  _createElementVNode("span", _hoisted_61, _toDisplayString($data.data.testProjectName), 1)
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _hoisted_63,
                  _createElementVNode("span", _hoisted_64, _toDisplayString($data.data.testCompanyName), 1)
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _hoisted_66,
                  _createElementVNode("span", _hoisted_67, _toDisplayString($data.data.entrustCompany), 1)
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _createElementVNode("span", _hoisted_70, _toDisplayString($data.data.smsNumber), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_71, [
              _hoisted_72,
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _hoisted_75,
                  _createElementVNode("span", _hoisted_76, _toDisplayString($data.data.productCompanyName), 1)
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _hoisted_78,
                  _createElementVNode("span", _hoisted_79, _toDisplayString($data.data.productName), 1)
                ]),
                _createElementVNode("div", _hoisted_80, [
                  _hoisted_81,
                  _createElementVNode("span", _hoisted_82, _toDisplayString($data.data.addressFull), 1)
                ])
              ])
            ]),
            ($data.data.testDescription)
              ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                  _hoisted_84,
                  _createElementVNode("div", _hoisted_85, _toDisplayString($data.data.testDescription), 1)
                ]))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, $data.activeTab === 'info']
          ]),
          _hoisted_86
        ], 64))
      : _createCommentVNode("", true),
    (!$data.loading && !$data.data.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
          _hoisted_88,
          _hoisted_89,
          _createElementVNode("button", {
            class: "back-home-btn",
            onClick: _cache[3] || (_cache[3] = (...args) => ($options.goBack && $options.goBack(...args)))
          }, "返回查询")
        ]))
      : _createCommentVNode("", true)
  ]))
}